import './src/styles/globals.css'

import PageRoot from './src/components/PageRoot';

export const wrapPageElement = PageRoot
